import {IAugmentedJQuery, IModule, ISCEService, ITimeoutService} from "angular";
import {Autentisering} from "felles/tjenester/Autentisering";
import {Debugger} from "debug";
import {PassordAutentiseringBasis} from "felles/komponenter/autentisering/passordautentiseringBasis";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {FellesAutentiseringsRessurs} from "felles/tjenester/ressurser/FellesAutentiseringsRessurs";
import {MeldingTilBruker} from "../../../../../felles/tjenester/MeldingTilBruker";
import {gettextCatalog} from "angular-gettext";


const css = require('./passordautentisering.scss');
const debug:Debugger = require('debug')('PassordAutentiseringKontroller');


export class PassordAutentiseringKontroller extends PassordAutentiseringBasis {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmPassordAutentisering', {
                bindings: {
                    forhåndsutfyltBrukernavn: '<brukernavn', //optional
                    tokenvarighet: '<',
                    vedValgt: '&',
                    vedKreverOppgraderingTil: '&',
                    vedAutentisert: '&'
                },
                controller: PassordAutentiseringKontroller.forInjisering(),
                template: require('./passordautentisering.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.ng.$timeout,
            regNavn.ng.$sce,
            regNavn.gettext.gettextCatalog,
            Autentisering.regNavn,
            FellesAutentiseringsRessurs.regNavn,
            MeldingTilBruker.regNavn,
            PassordAutentiseringKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery,
                $timeout: ITimeoutService,
                $sce: ISCEService,
                gettextCatalog: gettextCatalog,
                autentisering: Autentisering,
                fellesAutentiseringsRessurs: FellesAutentiseringsRessurs,
                meldingTilBruker: MeldingTilBruker) {
        super(autentisering, fellesAutentiseringsRessurs, meldingTilBruker, gettextCatalog, $timeout, $sce);
    }

    passordElement(): IAugmentedJQuery {
        return this.$element.find('input[name=passord]');
    }

}
